import { render, staticRenderFns } from "./CommuneChartSection.vue?vue&type=template&id=386c549a&scoped=true&"
import script from "./CommuneChartSection.vue?vue&type=script&lang=js&"
export * from "./CommuneChartSection.vue?vue&type=script&lang=js&"
import style0 from "./CommuneChartSection.vue?vue&type=style&index=0&id=386c549a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c549a",
  null
  
)

export default component.exports